/* eslint-disable import/no-unresolved */
import styled from "@emotion/styled";

import { minMedia } from "@styles";

export const ProductListHeaderText = styled.p`
  font-weight: 800;
  font-size: 24px;
`;

export const ProductListHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  max-width: fit-content;

  ${minMedia.mediumScreen`
      min-width: 160px;
  `};

  ${minMedia.smallScreen`
      min-width: 160px;
  `};
`;

export const ProductLenderContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: column;
  margin: 0 auto;
  max-width: fit-content;
  min-width: 200px;
  align-items: center;

  ${minMedia.smallScreen`
  flex-direction: row;
`};
`;

export const ProductLenderInnerContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: row:
`;
